import { BULK_MESSAGE_CSV_PROPOSAL } from "@/api/queries/bulkMessageProposal";
import { useLazyQuery } from "@apollo/client";

const IMAGE_SIZE = 48;

export function useBulkMessageProposalCsvLazy() {
  return useLazyQuery(BULK_MESSAGE_CSV_PROPOSAL, {
    variables: {
      orgId: "",
      imageSize: IMAGE_SIZE,
      csvFile: undefined,
    },
  });
}
